import { library } from '@fortawesome/fontawesome-svg-core';

import { 
  faSpinner,
  faTimes,
  faAngleLeft,

  faPlay,
  faPause,
  faBackward,
  faForward,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faSpinner,
  faTimes,
  faAngleLeft,

  faPlay,
  faPause,
  faBackward,
  faForward
);
